import React from "react";
import style from "./style.module.scss";

interface ButtonProps {
    type: "primary" | "secondary";
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    children: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

export const Button = (props: ButtonProps) => {
    const classes = [style.button];

    if (props.disabled) {
        classes.push(style.disabled);
    }

    if (props.type === "secondary") {
        classes.push(style.secondary);
    }

    if (props.className) {
        classes.push(props.className);
    }

    return (
        <button
            className={classes.join(" ")}
            onClick={(e) => props.onClick(e)}
            disabled={props.disabled}
        >
            {props.children}
        </button>
    );
};
